import firebaseApp from "./firebaseApp";
import "firebase/firestore";

function api() {
    return firebaseApp().firestore();
}

export default api;
